import React, { Component } from "react";
import {
    message,
    PageHeader,
    Spin,
    Row,
    Col,
    Select,
} from "antd";
import {
    Form,
    SelectItem,
    FormItem,
    InputNumberItem,
    DatePickerItem,
    ButtonItem,
    InputItem,
    NotificacionPolizas,
    ErrorItem
} from "../../../../Components/Items";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import SelectClientesItem from "../../../../Components/SelectClientesItem";

const { Option } = Select

moment.locale("es");

class AgregarAbonoCliente extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        datosFactura: undefined,
        todasBancos: [],
        objetoBancos: null,
        todasMonedas: [],
        objetoMonedas: null,
        todasProyectos: [],
        objetoProyectos: null,
        todasFormasDePago: [],
        objetoFormasDePago: null,
    };
    componentDidMount() {
        this.consultarTodo();
    }
    async consultarTodo() {
        this.setState({ loading: true });
        await axios
            .post(
                "abonosClientes/selectDatosParaAbono",
                { empresaId: this.props.empresaId },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    this.setState({
                        todasMonedas: res.data.monedas,
                        todasProyectos: res.data.proyectos,
                        todasFormasDePago: res.data.formasDePago,
                        todasBancos: res.data.bancos,
                        objetoMonedas: res.data.monedas.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre + " - " + value.abreviacion}
                                </Option>
                            );
                        }),
                        objetoProyectos: res.data.proyectos.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre}
                                </Option>
                            );
                        }),
                        objetoFormasDePago: res.data.formasDePago.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value?.c_FormaPago + ' - ' + value.descripcion}
                                </Option>
                            );
                        }),
                        objetoBancos: res.data.bancos.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre + ' - ' + value.banco}
                                </Option>
                            );
                        }),
                    });
                } else {
                    message.error(res.data.message || "Hubo un error al consultar los datos para el abono");
                }
            });
        this.setState({ loading: false });
    }
    onFinishFailed(e) {
        ErrorItem(e);
    }
    onFinish(values) {
        this.setState({ loading: true });
        axios
            .post(
                "abonosClientes/agregarAbonoCliente",
                {
                    ...values,
                    empresaId: this.props.empresaId,
                },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success(
                        "Se ha registrado un abono al cliente"
                    );
                    NotificacionPolizas(res.data.polizasId)
                    this.formRef.current.resetFields();
                    this.atras(res.data.codigo);
                } else {
                    message.error(res.data.message || "Hubo un error y no se efectuo el abono");
                }
            });
    }
    atras() {
        this.props.history.goBack();
    }
    render() {
        return (
            <>
                <PageHeader
                    onBack={this.atras.bind(this)}
                    title="Agregar Abono Cliente"
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                />
                <div className="card-background">
                    <Spin spinning={this.state.loading}>
                        <Form
                            ref={this.formRef}
                            name="agregarAbonoCliente"
                            layout
                            bottom={
                                <ButtonItem
                                    type="primary"
                                    htmlType="submit"
                                    style={{ display: "block", margin: "0 0 0 auto" }}
                                >
                                    Abonar
                                </ButtonItem>
                            }
                            onFinish={this.onFinish.bind(this)}
                            onFinishFailed={this.onFinishFailed}
                        >
                            <Row>
                                <Col span={8} xs={24} sm={24} lg={8} xl={8}>
                                    <FormItem
                                        label="Fecha de Pago"
                                        name="fechaPago"
                                        required
                                        margin
                                        initialValue={moment()}
                                    >
                                        <DatePickerItem
                                            placeholder="Fecha de Pago"
                                            allowClear={false}
                                        />
                                    </FormItem>
                                </Col>
                                <Col span={8} xs={24} sm={24} lg={8} xl={8}>
                                    <FormItem label="Proyecto" name="proyectoId" margin required>
                                        <SelectItem placeholder="Proyecto">
                                            {this.state.objetoProyectos}
                                        </SelectItem>
                                    </FormItem>
                                </Col>
                                <Col span={8} xs={24} sm={24} lg={8} xl={8}>
                                    <FormItem
                                        name="referencia"
                                        label="Referencia"
                                        pattern
                                    >
                                        <InputItem placeholder="Referencia" />
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={8} xs={24} sm={24} lg={8} xl={8}>
                                    <FormItem label="Banco Destino" name="bancoId" required>
                                        <SelectItem placeholder="Banco Destino">
                                            {this.state.objetoBancos}
                                        </SelectItem>
                                    </FormItem>
                                </Col>
                                <Col span={8} xs={24} sm={24} lg={8} xl={8}>
                                    <FormItem required number label='Monto' name='monto' type='number'>
                                        <InputNumberItem dinero placeholder='Monto' />
                                    </FormItem>
                                </Col>
                                <Col span={8} xs={24} sm={24} lg={8} xl={8}>
                                    <FormItem
                                        label="Cliente"
                                        name="clienteId"
                                        required
                                    >
                                        <SelectClientesItem
                                            empresaId={this.props.empresaId} // o donde sea que tengas almacenado el ID de la empresa
                                            headersToken={this.props.headersToken}
                                            sinBorde
                                            autoFocus
                                            dropdownMatchSelectWidth={600}
                                            width="100%"
                                            placeholder="Cliente"
                                        />
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={8} xs={24} sm={24} lg={8} xl={8}>
                                    <FormItem
                                        name="formaDePagoId"
                                        label="F Pago"
                                        margin
                                        required
                                    >
                                        <SelectItem placeholder="Forma de Pago">
                                            {this.state.objetoFormasDePago}
                                        </SelectItem>
                                    </FormItem>
                                </Col>
                                <Col span={8} xs={24} sm={24} lg={8} xl={8}>
                                    <FormItem
                                        required
                                        margin
                                        name="monedaId"
                                        label="Moneda"
                                        initialValue='60c7e4396465ad440c41c15a'
                                    >
                                        <SelectItem onChange={(value) => {
                                            if (value === '60c7e4396465ad440c41c15a') {
                                                this.formRef.current.setFieldsValue({ tipoDeCambio: 1 })
                                            }
                                        }} placeholder="Moneda">
                                            {this.state.objetoMonedas}
                                        </SelectItem>
                                    </FormItem>
                                </Col>
                                <Col span={8} xs={24} sm={24} lg={8} xl={8}>
                                    <FormItem noStyle shouldUpdate={(prev, curr) => prev.monedaId !== curr.monedaId}>
                                        {({ getFieldValue }) => {

                                            const monedaId = getFieldValue('monedaId')

                                            return (
                                                <FormItem
                                                    required
                                                    number
                                                    margin
                                                    label="T. Cambio"
                                                    name="tipoDeCambio"
                                                    type="number"
                                                    initialValue={1}
                                                >
                                                    <InputNumberItem
                                                        disabled={monedaId === '60c7e4396465ad440c41c15a'}
                                                        dinero
                                                        placeholder="T. Cambio"
                                                    />
                                                </FormItem>
                                            )
                                        }}
                                    </FormItem>
                                </Col>
                            </Row>
                        </Form>
                    </Spin>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
    };
};

export default connect(mapStateToProps)(AgregarAbonoCliente);
